import { Box } from '@mui/material';
import { FC } from 'react';
import { Set } from 'api/models/Sets';
import theme from 'App.theme';
import { InfoBox } from 'components/InfoBox';
import { useLanguage } from 'context/AppContext';
import { getSetDisplayLabel } from 'hooks/useSetDisplayLabel';

type Props = {
  members: Set[];
};

// names the sets on a consolidated set's tray; shared so every detail screen words and styles it the same way
const ConsolidatedMembersPanel: FC<Props> = ({ members }) => {
  const lang = useLanguage()[0].ConsolidatedSetGroup;

  if (!members.length) return null;

  return (
    <InfoBox
      sx={{
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: theme.layout.spacing.tiny,
        marginTop: theme.layout.spacing.small,
        marginBottom: 0,
      }}
    >
      <Box sx={{ fontSize: 12, color: theme.greys.GREY3 }}>{lang.membersHeading}</Box>
      {members.map(member => (
        <Box key={member.kitInstanceId}>{getSetDisplayLabel(member)}</Box>
      ))}
    </InfoBox>
  );
};

export default ConsolidatedMembersPanel;
